<template>
          <v-container fluid>
          <v-card v-if="hasPermission('CAN_UPLOAD_BULK')">
            <v-alert
              value="message" v-if="message"
              type="success"
              outline
            > <span> {{ message }} </span>
            </v-alert>

             <v-alert
              value="error" v-if="error"
              type="warning"
              outline
            > <span> {{ error }} </span>
            </v-alert>

            <v-flex xs8 pa-4>

             <v-form ref="form">
               <label>File
                 <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" required/>
               </label>
            
                <v-card-actions>
                  <v-btn @click="uploadFile" color="#1f5b41" class="white--text">Upload</v-btn>
                </v-card-actions>
              </v-form>
            </v-flex>        
          </v-card>
          <v-data-table
              :headers="headers"
              :items="files"
              :pagination.sync="pagination"
              :total-items="totalFiles"
              :loading="loading"
              class="elevation-1 mt-3"
            >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.fileName }}</td>
              <td>{{ props.item.createdBy }}</td>
              <td>{{ props.item.createdAt }}</td>
              <td>{{ props.item.approved }}</td>
            </template>
            <template slot="no-data">
              <p> No data Found </p>
              <v-btn color="primary" @click="getDataFromApi">Reload</v-btn>
            </template>
           </v-data-table>
        
        </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
  name: 'uploadfile',
  data: function() {
    return {
      file: '',
      message: '',
      error: '',
      canUploadFile: true,
      files: [],
      loading: true,
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'File Name', value: 'fileName' },
        { text: 'Created By', value: 'createdBy' },
        { text: 'Created At', value: 'createdAt' },
        { text: 'Approved', value: 'approved' }
      ],
      pagination: {sortBy: 'id', descending: true},
      totalFiles: 0,
      permissions: []
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getDataFromApi()
      },
      deep: true
    }
  },
  mounted() {
    var localUserString = window.localStorage.getItem('user')
    var localUser = JSON.parse(localUserString)
    this.permissions = localUser.permissions
  },
  methods: {
    hasPermission(permission) {
      return this.permissions.includes(permission)
    },
    uploadFile() {
      this.message = ''
      this.error = ''
      var url = config.serverURI + '/bulk_upload'
      var token = store.state.token
      let formData = new FormData()
      formData.append('file', this.file)
      axios.post(url, formData, {
        headers: {
          'Authorization': token,
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => {
          if (response.status !== 200) {
            this.error = response.statusText
            console.log('Error is ' + this.error)
            return
          }
          if (response.data.error !== false) {
            this.error = response.data.message
            console.log('Error is ' + this.error)
            return
          }
          this.$refs.form.reset()
          this.file = ''
          this.$refs.file = null
          this.message = response.data.message
          this.getDataFromApi()
        })
        .catch(error => {
          console.log('error', error.response)
          var data = error.response.data
          console.log(data.message)
          if (data.message === 'Unauthorized') {
            console.log('redirecting')
            window.location = '/login'
          } else {
            this.error = data.message
          }
        })
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0]
    },
    getDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let items = this.getFiles()
        const total = items.length

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy]
            const sortB = b[sortBy]

            if (descending) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
        }

        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
    getFiles() {
      var url = config.serverURI + '/bulk_upload'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token
        }
      })
          .then(response => {
            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.files = response.data
            this.totalFiles = this.files.total
          })
          .catch(error => {
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      return this.files
    }
  }
}
</script>
<style>
.info-box {
  cursor: pointer;
}

.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}

.fullCanvas {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// BulkUpload.vue?34be6505